<template>
    <div>
        <div class="modal-window" :class="{'open': video_box_open}" @click="video_box_open = false"
             v-if="video_box_open">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="video_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">{{ video_title }}</h1>
                </div>
                <div class="modal-content mb-6">
                    <vue-vimeo-player ref="player" :video-id="video_embed_id" :options="{ responsive: true }"/>
                </div>
            </div>
        </div>

        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    The Procurement Act
                </div>
            </div>
            <div class="main">
                <div class="content">
                    Stay ahead of the curve with our exclusive free webinars on the Procurement Act 2023
                    tailored especially for Approved Commercial Partners.
                </div>
            </div>
        </div>

        <div class="landing-page-panels">
            <div class="landing-page-panel" @click="openVideo({title: 'Navigating the Procurement Act 2023 Webinar - Part 1', video_embed_id: 1067811738})">
                <div class="box">
                    <div class="image">
                        <img src="https://s3.eu-west-2.amazonaws.com/epwin-portal/commercial_training_course_images/1742556482178.jpg">
                    </div>
                    <div class="content">
                        <div class="title">
                            Navigating the Procurement Act 2023 Webinar - Part 1
                        </div>
                        <div class="description">
                            Stay ahead of the curve with our exclusive free webinars on the Procurement Act 2023 tailored especially for Epwin Window Systems Approved Commercial Partners.
                        </div>
                    </div>
                </div>
            </div>

            <div class="landing-page-panel" @click="openVideo({title: 'Navigating the Procurement Act 2023 - Part 2', video_embed_id: 1067814398})">
                <div class="box">
                    <div class="image">
                        <img src="https://s3.eu-west-2.amazonaws.com/epwin-portal/commercial_training_course_images/1742557135300.jpg">
                    </div>
                    <div class="content">
                        <div class="title">
                            Navigating the Procurement Act 2023 - Part 2
                        </div>
                        <div class="description">
                            Second part of the webinar  Navigating the Procurement Act 2023  to tackle challenges that may arise when using the new platform for public procurement.
                        </div>
                    </div>
                </div>
            </div>

            <div class="landing-page-panel" @click="openVideo({title: 'Navigating the Procurement Act 2023 - Follow Up', video_embed_id: 1068067511})">
                <div class="box">
                    <div class="image">
                        <img src="https://s3.eu-west-2.amazonaws.com/epwin-portal/commercial_training_course_images/1742893257466.jpg">
                    </div>
                    <div class="content">
                        <div class="title">
                            Navigating the Procurement Act 2023 - Follow Up
                        </div>
                        <div class="description">
                            Watch the Q&A session to follow up on the launch of the central digital platform.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {vueVimeoPlayer} from 'vue-vimeo-player';

export default {
    props: [
        'logged_in_user',
    ],
    components: {
        vueVimeoPlayer
    },
    data() {
        return {
            loading: true,
            video_box_open: false,
            video_title: '',
            video_embed_id: '',
        };
    },
    methods: {
        openVideo(video) {
            this.video_title = video.title;
            this.video_embed_id = video.video_embed_id;
            this.video_box_open = true;
        },
    },
};
</script>
